<div class="colour" *ngFor="let colour of colours">
    <div class="colour-variant" *ngFor="let variant of colour.variants; let i = index" [ngStyle]="{
        backgroundColor: 'var(--colour-' + variant + ')',
        boxShadow: 'inset 0 0 0 1px var(--colour-' + colour.border + ')'
    }" (click)="setValue(variant)">
        <cll-icon *ngIf="value === variant" [ngStyle]="{
            color: 'var(--colour-' + colour.textColours[i] + ')'
        }">check</cll-icon>
    </div>
</div>